export default __webpack_public_path__ + "static/media/icon-smile-dark.c05febb5.svg";